var React = require('react');

function Clean (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M19.36 2.72l1.42 1.42-5.72 5.71c1.07 1.54 1.22 3.39.32 4.59L9.06 8.12c1.2-.9 3.05-.75 4.59.32l5.71-5.72M5.93 17.57c-2.01-2.01-3.24-4.41-3.58-6.65l4.88-2.09 7.44 7.44-2.09 4.88c-2.24-.34-4.64-1.57-6.65-3.58z"}));
}

Clean.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Clean;

Clean.default = Clean;
